import { render, staticRenderFns } from "./CreateOrUpdateActivity.vue?vue&type=template&id=f5db0cc4&scoped=true"
import script from "./CreateOrUpdateActivity.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateActivity.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdateActivity.vue?vue&type=style&index=0&id=f5db0cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5db0cc4",
  null
  
)

export default component.exports